import * as React from 'react';
import * as styles from './request_error.css';
import { Button } from '@cian/ui-kit';

const RequestError = () => (
  <div className={styles['container']}>
    <div className={styles['text']}>Произошла ошибка</div>
    <Button data-name="Retry" size="XS" theme="fill_primary" onClick={() => window.location.reload()}>
      Повторить попытку
    </Button>
  </div>
);

export { RequestError };
